// Module
var code = "<style>:host{--transition:max-height 0.2s ease-in-out;--accordion-max-height:0px;max-height:var(--accordion-max-height);transition:var(--transition);display:block;overflow:hidden}</style> <slot></slot>";
// Exports
export default code;